// MazeApp
//
//  desc:
//         
//
//
//  props:
//

import React from 'react';
import './index.css';

import Maze from '../../lib/maze/maze.js';
import PathBuilder from '../../lib/maze/pathBuilder.js';

import MazePrinter from '../MazePrinter';


class MazeApp extends React.Component
{
 constructor(props)
 {
    super(props);

    this.state =  { maze: null, 
                  }

    this.windowRef = React.createRef();

    this.onNewMazeClick = this.onNewMazeClick.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);

  }

  componentDidMount()
  { 
    window.addEventListener("resize", this.handleWindowResize);   //add a window resize event listener 

    //using the current div width to dtermine the max row size we should use for generating a maze
    //  cuz we want to make sure, as well as possible, that the maze will fit on the window space provided 
    let windowWidth =  this.windowRef.current.offsetWidth
    let maxRowRooms = this.getMaxRowRooms(windowWidth)
   
    let maze = this.buildMaze(maxRowRooms, 30);
 
    this.setState({ maze: maze, windowWidth: windowWidth});
 }


  componentWillUnMount() 
  {
    window.addEventListener("resize", this.handleWindowResize);
  } 


  handleWindowResize(e)
  {
    let windowWidth =  this.windowRef.current.offsetWidth
    this.setState({ windowWidth: windowWidth});

    //TODO: we *might* want to build a new maze at this point to make sure that we have a maze that fits on the screen...

  }



  getMaxRowRooms(windowWidth)
  { //TODO: hard coding, for now, the width of a room to be 32x32
    let maxRooms = Math.floor(windowWidth / 32)
    return maxRooms;
  }


  buildMaze(width, height)
  {
    let tempMaze = new Maze({width: width, height: height});
    tempMaze.buildRooms();
    let pathBuilder = new PathBuilder({maze: tempMaze, depthSearch: false});
    pathBuilder.chooseEntranceAndExit();
    pathBuilder.buildPaths();

    return pathBuilder.m_maze;
  }


  onNewMazeClick()
  {
    console.info("TODO: current window state width: ", this.state.windowWidth)
    let maxRowRooms = this.getMaxRowRooms(this.state.windowWidth)
    let newMaze = this.buildMaze(maxRowRooms,30);
    this.setState({maze: newMaze});
  }


  renderMazeOptionButtons()
  {
    let buttonHtml =  <div>
                        <div className='ma-button maze-regenerate' onClick={this.onNewMazeClick}> New Maze! </div>
                      </div>

    return buttonHtml;
  }


  renderMazePrinter()
  {
    let mazeHtml = null;

    //only attempt to render a maze if a maze actually exists! 
    if (this.state.maze)
    {
      mazeHtml = <MazePrinter puzzle={this.state.maze} /> 
    }

    return mazeHtml;
  }


  render()
  {
    return(
      <div ref={this.windowRef} >

        {this.renderMazeOptionButtons()}

        {this.renderMazePrinter()}

      </div>
    );
  }

}

export default MazeApp;
